module.exports = __webpack_public_path__ + "img/Lincoln-Tech-Logo.8a2c18e3.png";